import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, from } from 'rxjs';

import { User } from '../models/user';
import { Candidate } from '../models/candidate';
import { Router } from '@angular/router';
import { JsonPipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  public REST_API_SERVER:string = `${environment.REST_API_URL}/api/web/${environment.version}`;

  constructor(private http:HttpClient,
      private router:Router) { }

  public login(data:any):Observable<User[]>{
    return this.http.post<User[]>(`${this.REST_API_SERVER}/security/login`,data);
  }
  public createAccount(data:any):Observable<User[]>{
    return this.http.post<Candidate[]>(`${this.REST_API_SERVER}/security/login`,data);
  }

  public forgotPassword(data:any):Observable<any>{
    return this.http.post<any>(`${this.REST_API_SERVER}/security/forgotpassword`,data);
  }

  public checkResetPasswordLinkValidOrNot(data:any):Observable<any>{
    return this.http.post<any>(`${this.REST_API_SERVER}/security/checkresetpasswordlinkvalid`,data);
  }

  public resetPassword(data:any):Observable<any>{
    return this.http.post<any>(`${this.REST_API_SERVER}/security/resetpassword`,data);
  }

  public setToken(data:any):void{
    localStorage.setItem('access_token', data.token);
    this.setIsUserReport(data);
    this.setRole(data);
    this.setOrgId(data);
    this.setUserDetails(data);
    this.setUserName(data.name);
  }

  public getToken():string {
    return localStorage.getItem('access_token');
  }

  public isLoggedIn(): boolean {
    let authToken = localStorage.getItem('access_token');
    return (authToken !== null) ? true : false;
  }

  public logout():void {
    let removeToken = localStorage.removeItem('access_token');
    let role = localStorage.removeItem('role');
    let org_id = localStorage.removeItem('org_id');
    let user_details = localStorage.removeItem('user_details');
    let is_users_report = localStorage.removeItem('is_users_report');
    this.removeUserName();
    this.removeEventType();
    this.removeWorkingOn();
    if (removeToken == null && role ==null && org_id == null && user_details == null && is_users_report == null) {
       this.router.navigate(['/login']);
    }
  }

  public setRole(data){
    localStorage.setItem('role',JSON.stringify(data.roles));
  }
  
  public setIsUserReport(data){
    localStorage.setItem('is_users_report', data.is_users_report);
  }

  public getRole(){
    return localStorage.getItem('role');
  }

  public hasRole(){

    let roles = JSON.parse(localStorage.getItem('role'));

    if (roles && Object.keys(roles).length){
      return Object.keys(roles)[0];
    }
    
    return '0';
  }

  public setOrgId(data){
    localStorage.setItem('org_id',data.org_id);
  }

  public getOrgId(){
    return localStorage.getItem('org_id');
  }

  public setUserDetails(data){

    var user_details = {
      user_id : data.id,
      plan_id : data.plan_id,
      reporting_to : data.reporting_to,
      shift : data.shift,
      timezone: data.timezone,
      username: data.name,
      profile:data.profile
    };

    localStorage.setItem('user_details',JSON.stringify(user_details));

  }

  public getUserDetails(){
    let user_details = JSON.parse(localStorage.getItem('user_details'));
    return user_details;
  }

  public setUserName(UserName:string):void{
    localStorage.setItem('user_name',UserName);
  }

  public getUserName():string{
    return localStorage.getItem('user_name');
  }

  public removeUserName():void{
    localStorage.removeItem('user_name');
  }

  public setEventType(eventType:string):void{
    localStorage.setItem('event_type',eventType);
  }

  public getEventType():string{
    return localStorage.getItem('event_type');
  }

  public removeEventType():void{
    localStorage.removeItem('event_type');
  }

  public setWorkingOn(test:string){
    localStorage.setItem('working_on',test);
  }

  public getWorkingOn(){
    return localStorage.getItem('working_on');
  }

  public removeWorkingOn(){
    localStorage.removeItem('working_on');
  }
 
}
